import React from "react";
import { FaBullhorn } from "react-icons/fa";
import { IoMdWarning } from "react-icons/io";
import { Container, Content, Header } from "./styles";
import Button from "../../ButtonsAndLinks/Button";
export var Warning = function (_a) {
    var title = _a.title, content = _a.content, footer = _a.footer, show = _a.show, type = _a.type, icon = _a.icon, containerStyles = _a.containerStyles, onClick = _a.onClick;
    var styles = {
        success: {
            iconColor: "#3BD2C1",
            backColor: "#ecfffd",
            icon: React.createElement(FaBullhorn, null)
        },
        warning: {
            iconColor: "#FFA814",
            backColor: "#FFF6E5",
            icon: React.createElement(IoMdWarning, null)
        },
        danger: {
            iconColor: "#FF2C3A",
            backColor: "#FFF0F2",
            icon: React.createElement(IoMdWarning, null)
        }
    };
    return (React.createElement(Container, { show: show, style: containerStyles },
        React.createElement(Header, { backColor: styles[type].backColor, iconColor: styles[type].iconColor },
            icon || styles[type].icon,
            React.createElement("h1", null, "Novidade: "),
            React.createElement("span", null, title)),
        React.createElement(Content, null,
            React.createElement("div", { style: { maxWidth: "calc(100% - 48px)" } }, content),
            React.createElement(Button, { title: "OK", containerStyles: { width: 48, height: 48 }, buttonColor: "#2ec9b7", onClick: function (e) {
                    if (onClick) {
                        onClick(e);
                    }
                } })),
        footer && React.createElement("div", null, footer)));
};
//# sourceMappingURL=index.js.map